import { render } from "./DataTableBody.vue?vue&type=template&id=da5bea54"
import script from "./DataTableBody.vue?vue&type=script&lang=js"
export * from "./DataTableBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__